<template>
  <app-section-wrap v-if="!$isSsoUser"
  :modifier="'login update-password'">
    <div column="xl-3">
      <password-validator
        v-model="passwordValid"
        :currentPasswordRequired="true"
        :currentPassword="currentPassword"
        :newPassword="newPassword"
        :confirmNewPassword="confirmNewPassword"
      />
    </div>

    <div column="xs-12 s-12 m-6 xl-6 ">
      <div class="card">
        <h1 class="_text-center _mbxs">
          Change Your Password
        </h1>
        <div v-if="authError" class="_flex justify-center">
          <p class="lips text">{{authMessage}}</p>
        </div>
        <p class="lips"><i>Please provide a new password. The verification code has been sent to the email address on file.</i> In some cases, it can take up to 90 minutes.</p>
        <form @submit.prevent="updatePassword" method="POST">
          <div class="form-group">
            <div>
              <label for="currentPassword">
                Verification Code
              </label>
              <app-password-input
                id="verificationToken"
                name="verificationToken"
                value=""
                required
                v-model="verificationToken"
                autofocus="true"
                class="_mbxs"
              />
            </div>
            <div>
              <label for="currentPassword">
                Current Password
              </label>
              <app-password-input
                id="currentPassword"
                name="currentPassword"
                minlength="6"
                value=""
                required
                v-model="currentPassword"
                class="_mbxs"
              />
            </div>
            <label for="newPassword">
              New Password
            </label>
            <app-password-input
              class="_mbxs"
              id="newPassword"
              name="newPassword"
              value=""
              required
              v-model="newPassword"
            />
            <label for="confirmNewPassword">
              Confirm New Password
            </label>
            <app-password-input
              id="confirmNewPassword"
              name="confirmNewPassword"
              value=""
              required
              v-model="confirmNewPassword"
            />
          </div>
          <async-button type="submit" class="_mtxs --sm" :executing="updatingPassword" :disabled="passwordValid || updatingPassword">
            <template #buttonContent>
              <span>Update Password</span>
            </template>
          </async-button>

        </form>
        <async-button @clicked="requestNewToken" class="white --sm" :executing="requestingNewToken" :disabled="requestingNewToken || newTokenSent">
          <template #buttonContent>
            <span v-if="newTokenSent">
              Check Your Email
              <font-awesome-icon icon='check-circle' class='_mlxs' aria-label="Check"/>
            </span>
            <span v-else>
                Request New Code
            </span>
          </template>
        </async-button>
        <a @click="$router.go(-1)">Back to My Profile</a>
      </div>
    </div>

  </app-section-wrap>
</template>

<script>
  import AppSectionWrap from '@molecules/SectionWrap.vue'
  import AsyncButton from '@molecules/AsyncButton.vue'
  import PasswordValidator from '@organisms/PasswordValidator'
  import AppPasswordInput from '@atoms/PasswordInput'
  import { mapGetters } from 'vuex'

  export default {
    components: {
      AppSectionWrap,
      AsyncButton,
      AppPasswordInput,
      PasswordValidator
    },
    data() {
      return {
        passwordValid: true,
        currentPassword: '',
        newPassword: '',
        confirmNewPassword: '',
        verificationToken: '',
        newTokenSent: false
      }
    },
    computed: {
      ...mapGetters([
        'authMessage',
        'authError',
        'updatingPassword',
        'userId',
        'requestingNewToken'
      ]),
      formObject() {
        return {
          oldPassword: this.currentPassword,
          newPassword: this.newPassword,
          userId: this.userId,
          token: this.verificationToken
        }
      }
    },
    methods: {
      cycleAttestationCounter() {
        // kill the old count poller
        this.$store.commit('CLEAR_ATTESTATION_POLLING_HANDLE');
        // and cycle it to get a new token
        this.$store.dispatch('CYCLE_ATTESTATION_COUNT');
      },
      updatePassword () {
        this.$store.dispatch('UPDATE_YOUR_PASSWORD', {
          body: this.formObject
        })
          .then(success => {
            if (success) { 
              this.cycleAttestationCounter();
              this.$router.go(-1);
            }
          })
      },
      requestNewToken () {
        this.$store.dispatch('GET_NEW_TOKEN', {
          body: { userId: this.userId }
        })
          .then(success => {
            if (success) { this.newTokenSent = true } else {} // todo
          })
      }
    },
    created () {
      // Fire off a token request at the behest of EyeMed IT
      this.$store.dispatch('GET_NEW_TOKEN', {
        body: { userId: this.userId }
      })
    }
  }
</script>
